
import { format } from "date-fns";
import type { Activity } from "@/types";

interface NotificationItemProps {
  notification: Activity;
  onClick: (id: string) => void;
}

export function NotificationItem({ notification, onClick }: NotificationItemProps) {
  // Determine if this is a client removal notification
  const isClientRemoval = notification.type === 'new_client' && 
                         notification.data && 
                         typeof notification.data === 'object' &&
                         'action' in notification.data &&
                         notification.data.action === 'removed';
  
  // Apply special styling for removal notifications
  const titleClass = isClientRemoval 
    ? "text-sm font-medium text-red-400" 
    : "text-sm font-medium text-white";

  return (
    <div
      className={`p-4 transition-colors hover:bg-white/5 ${
        !notification.is_read ? 'bg-white/5' : ''
      }`}
      onClick={() => onClick(notification.id)}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className={titleClass}>
            {notification.title}
          </p>
          <p className="text-sm text-white/70">
            {notification.description}
          </p>
          <p className="text-xs text-white/50">
            {format(new Date(notification.created_at), 'MMM d, h:mm a')}
          </p>
        </div>
        {!notification.is_read && (
          <div className="h-2 w-2 rounded-full bg-blue-500" />
        )}
      </div>
    </div>
  );
}
